import {Component, Input, OnInit} from '@angular/core';
import {InfoPageComponent} from '../../shared/components/info-page/info-page.component';
import {ReservationService} from '../../core/api/reservation.service';
import {Reservation} from '../../shared/models/reservation.model';
import {LangService} from '../../core/services/lang.service';
import {SafeResourceUrl} from '@angular/platform-browser';
import {VideoEmbedService} from '../../core/services/video-embed.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  imports: [
    InfoPageComponent
  ]
})
export class WelcomeComponent implements OnInit {
  @Input() videoSrc?: SafeResourceUrl | null;
  @Input() imageSrc?: string | null;
  @Input() owner?: string;
  @Input() welcome_text?: string;

  reservation: Reservation | null = null;

  constructor(private reservationService: ReservationService, private langService: LangService, private videoEmbed: VideoEmbedService) {
  }

  ngOnInit(): void {
    this.loadReservation();
  }

  private loadReservation(): void {
    this.reservationService.getReservation().subscribe({
      next: (reservation) => {
        this.reservation = reservation;
        this.videoSrc = this.videoEmbed.toYouTubeEmbedSrc(reservation.data.apartment.welcome_video);
        this.imageSrc = reservation.data.apartment.welcome_picture;
        this.owner = reservation.data.apartment.owner;
        this.welcome_text = this.getLocalizedWelcomeText(reservation.data.apartment.welcome_text);
      },
      error: (error) => {
        console.error('Error al obtener la reserva:', error);
      }
    });
  }

  private getLocalizedWelcomeText(welcomeTextJson: string): string {
    try {
      const selectedLang = this.langService.currentLang();
      const welcomeTextObj = JSON.parse(welcomeTextJson);
      let localizedText = welcomeTextObj[selectedLang];
      if (!localizedText) {
        localizedText = welcomeTextObj[environment.defaultAppLang] || '';
      }
      return localizedText;

    } catch (error) {
      console.error('Error al parsear el welcome_text JSON:', error);
      return '';
    }
  }

}
